import updateGlobalFolderViewState from '../services/updateGlobalFolderViewState';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { action, select } from 'satcheljs/lib/legacy';
import { MAX_LIST_VIEW_WIDTH, MIN_LIST_VIEW_WIDTH, MAX_LIST_VIEW_HEIGHT, MIN_LIST_VIEW_HEIGHT, } from 'owa-mail-list-dimensions';
export default action('setListViewDimension')(select({
    userOptions: function () { return getUserConfiguration().UserOptions; },
    viewStateConfiguration: function () { return getUserConfiguration().ViewStateConfiguration; },
})(function setListViewDimension(listViewDimension, isWidth, state) {
    // We limit the list view dimension between min and max dimensions allowed
    var listViewDimensionToStore = listViewDimension;
    var maxDimension = isWidth ? MAX_LIST_VIEW_WIDTH : MAX_LIST_VIEW_HEIGHT;
    var minDimension = isWidth ? MIN_LIST_VIEW_WIDTH : MIN_LIST_VIEW_HEIGHT;
    if (listViewDimension > maxDimension) {
        listViewDimensionToStore = maxDimension;
    }
    else if (listViewDimension < minDimension) {
        listViewDimensionToStore = minDimension;
    }
    var globalFolderViewState = JSON.parse(state.viewStateConfiguration.GlobalFolderViewState || '{}');
    if (isWidth) {
        globalFolderViewState.Width = listViewDimensionToStore;
    }
    else {
        globalFolderViewState.Height = listViewDimensionToStore;
    }
    state.viewStateConfiguration.GlobalFolderViewState = JSON.stringify(globalFolderViewState);
    updateGlobalFolderViewState();
}));
//# sourceMappingURL=setListViewDimension.js.map